import { Button, Control, Field, Icon, Input } from 'rbx';
import * as React from 'react';
import { useMutation } from '@apollo/client';

import { LINE_ITEM_UPDATE_MUTATION } from './../../../api/GraphQLQueries/LineItem';
import { notification } from './../../../utils/notification';

interface IProps {
    lineItemId: number;
    quantity?: string;
}

const BasketUpdateQuatntiyMutation: React.FC<IProps> = ({ lineItemId, quantity }) => {
    const [value, setValue] = React.useState(quantity || '');
    const [quantityChanged, setQuantityChanged] = React.useState(false);

    const [updateQuantityMutation] = useMutation(LINE_ITEM_UPDATE_MUTATION, {
        onCompleted: () => {
            notification.success('Successfully updated quantity');
            setQuantityChanged(false);
        },
        onError: () => {
            notification.error('Quantity update error');
        },
    });

    const handleUpdateQuantity = () => {
        updateQuantityMutation({ variables: { lineItem: { id: lineItemId, quantity: value } } });
    };

    const onKeyPair = (e: any) => {
        if (e.key === 'Enter') {
            handleUpdateQuantity();
            e.currentTarget.blur();
        }
    };

    const updateDetails = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
        setQuantityChanged(true);
    };

    return (
        <Field kind={quantityChanged ? 'addons' : undefined} className="is-narrow">
            <Control expanded={true}>
                <Input
                    as="input"
                    type="text"
                    value={value}
                    onChange={updateDetails}
                    onKeyPress={onKeyPair}
                />
            </Control>
            {quantityChanged && (
                <Control>
                    <Button
                        color="primary"
                        disabled={!quantityChanged}
                        onClick={handleUpdateQuantity}
                    >
                        <Icon size="small">
                            <i className="fa fa-arrow-alt-right" />
                        </Icon>
                    </Button>
                </Control>
            )}
        </Field>
    );
};

export default BasketUpdateQuatntiyMutation;
